import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService, LoaderService } from '@shared';
import { Tier, TiersService } from '@shared-data';

@Component({
  selector: 'app-align-tier',
  templateUrl: './align-tier.component.html',
  styleUrl: './align-tier.component.scss',
})
export class AlignTierComponent {
  @Input()
  tierToAlign!: Tier;

  @Output()
  onConfirm: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private tierService: TiersService,
    private messageService: MessageService,
    private loaderService: LoaderService,
  ) {}

  onCancel() {
    this.onConfirm.emit(false);
  }

  onProceed() {
    this.loaderService.show();
    this.tierService.syncTier(this.tierToAlign.id).subscribe({
      next: () => {
        this.onConfirm.emit(true);

        this.loaderService.hide();
      },
      error: (err) => {
        const validationError = err?.error;
        if (validationError) {
          this.messageService.error(validationError);
        } else {
          this.messageService.error('Error syncing tier');
        }
        this.tierToAlign.isSynchedToKing = false;
        this.loaderService.hide();
        this.onConfirm.emit(false);
      },
    });
  }
}
